import { initDonateForm } from './macmillan.donationsForm.js';
import { initDonationAmount } from './macmillan.utils.js';
import { initDonations } from './macmillan.js';

$(() => {
    initDonateForm(); // Main donate
    initDonationAmount();
    initDonations();
})
